import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-catalyst-core/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Seo = makeShortcode("Seo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Seo title="History" mdxType="Seo" />
    <h1 {...{
      "id": "history"
    }}>{`History`}</h1>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "720px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "62.5%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAUBAgP/xAAWAQEBAQAAAAAAAAAAAAAAAAABAAL/2gAMAwEAAhADEAAAAWJlGFOUG//EABoQAQACAwEAAAAAAAAAAAAAAAMREwABAgT/2gAIAQEAAQUC2B5QMerg+Hu1N0YzWp//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAcEAACAgIDAAAAAAAAAAAAAAAAARIyAhEhYaH/2gAIAQEABj8Cqii0NY8dFfSpKCR//8QAGxAAAwEBAAMAAAAAAAAAAAAAAAERMSFRYXH/2gAIAQEAAT8hpTa/iGi2KwaRcLB6Lc0coteyxhTyf//aAAwDAQACAAMAAAAQKy//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAfEAEBAAICAQUAAAAAAAAAAAABEQAhMUFhcYGhseH/2gAIAQEAAT8QTshHhZqePzHUqWzlcbQ6NYk6r6PvggoEcL8GNOptvf6yyqiEpna6z//Z')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/static/0e6b2fa728c2d85b2af68ea598175763/a3012/railroad_map.webp 360w", "/static/0e6b2fa728c2d85b2af68ea598175763/bc514/railroad_map.webp 720w"],
            "sizes": "(max-width: 720px) 100vw, 720px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/static/0e6b2fa728c2d85b2af68ea598175763/158ba/railroad_map.jpg 360w", "/static/0e6b2fa728c2d85b2af68ea598175763/80e3c/railroad_map.jpg 720w"],
            "sizes": "(max-width: 720px) 100vw, 720px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/static/0e6b2fa728c2d85b2af68ea598175763/80e3c/railroad_map.jpg",
            "alt": "Beakers",
            "title": "Beakers",
            "loading": "lazy",
            "decoding": "async",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      